"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = void 0;
exports.size = {
  xxxLarge_break: '1920px',
  xxLarge_break: '1440px',
  xLarge_break: '1200px',
  large_break: '1024px',
  middle_break: '720px',
  medium_break: '640px',
  small_break: '375px',
  tiny_break: '320px'
};
var breakPoints = {
  xxxLarge_break: "(min-width: ".concat(exports.size.xxxLarge_break, ")"),
  xxLarge_break: "(min-width: ".concat(exports.size.xxLarge_break, ")"),
  xLarge_break: "(min-width: ".concat(exports.size.xLarge_break, ")"),
  large_break: "(min-width: ".concat(exports.size.large_break, ")"),
  middle_break: "(min-width: ".concat(exports.size.middle_break, ")"),
  medium_break: "(min-width: ".concat(exports.size.medium_break, ")"),
  small_break: "(min-width: ".concat(exports.size.small_break, ")"),
  tiny_break: "(min-width: ".concat(exports.size.tiny_break, ")")
};
exports.default = breakPoints;